import React from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';

import { ActivityLogEmployeeEmailReceived_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import logError from 'src/utils/logError';

import ActivityLogBase from '../../Helpers/ActivityLogBase';
import ActivityLogFeedEmail from '../ActivityLogFeedEmail';

interface Fragments {
  activityLog: ActivityLogEmployeeEmailReceived_ActivityLogFragment;
}

type EmployeeEmailReceivedDetails = {
  __typename?: 'ActivityLogEmployeeEmailReceivedDetails';
  fromEmailAddress: string;
  toEmailAddress: string;
  ccAddresses: string[];
  subject: string;
  body: string;
};

const ActivityLogEmployeeEmailReceived: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { t } = useTranslation();
  const details = activityLog.details as unknown as EmployeeEmailReceivedDetails | null | undefined;

  // eslint-disable-next-line no-underscore-dangle
  if (details?.__typename !== 'ActivityLogEmployeeEmailReceivedDetails') {
    logError('ActivityLogEmployeeEmailReceived: details is not ActivityLogEmployeeEmailReceivedDetails');
    return null;
  }

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.repliedViaEmail"
    >
      <ActivityLogFeedEmail
        emailAddress={details.fromEmailAddress}
        emailAddressLabel={t('hiring-dashboard-candidates:candidates.activityLog.from', { defaultValue: 'From:' })}
        ccAddresses={details.ccAddresses}
        subject={details.subject}
        body={details.body}
      />
    </ActivityLogBase>
  );
};

ActivityLogEmployeeEmailReceived.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogEmployeeEmailReceived_activityLog on ActivityLog {
      id
      activityType
      details {
        ... on ActivityLogEmployeeEmailReceivedDetails {
          __typename
          employeeId
          employeeName
          fromEmailAddress
          toEmailAddress
          ccAddresses
          subject
          body
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogEmployeeEmailReceived;
